import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="py-12 bg-darker border-t border-white/5 text-center px-4" data-id="element-67">
      <div className="container mx-auto max-w-3xl" data-id="element-68">
        <p className="text-gray-500 text-sm leading-relaxed mb-6 font-sans" data-id="element-69">
          Este producto es un ebook digital de carácter educativo e informativo.
          Los resultados dependen del esfuerzo y aplicación de cada persona. No
          garantizamos ingresos específicos.
        </p>
        <p className="text-gray-600 text-xs mb-6 font-sans" data-id="element-70">
          © 2026 Efectivo Inmediato. Todos los derechos reservados.
        </p>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-gray-500" data-id="element-71">
          <Link to="/terminos-y-condiciones" className="hover:text-neon transition-colors" data-id="element-72">
            Términos y Condiciones
          </Link>
          <Link to="/politica-de-privacidad" className="hover:text-neon transition-colors" data-id="element-73">
            Política de Privacidad
          </Link>
          <Link to="/contacto" className="hover:text-neon transition-colors" data-id="element-74">
            Contacto
          </Link>
        </div>
      </div>
    </footer>;
};